import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class BuildingAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.buildSection = document.querySelector('#building-section');
    this.buildBeforeClone = this.cloneNextSibling(this.buildSection.previousElementSibling);
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    this.buildBeforeClone.classList.remove('invisible')
    setTimeout(() => {
      this.buildBeforeClone.classList.add('invisible')
    }, this.ANIM_DUR + this.EXTRA_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

  // -- 1.2. Interract back
  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeave() {
    window.dispatchEvent(this.transitionStart)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.hideVideo()
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

}
